/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_Urgentquestion1Inputs */

const he_contact_success_urgentquestion1 = /** @type {(inputs: Contact_Success_Urgentquestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צריך תשובה מהירה יותר?`)
};

const en_contact_success_urgentquestion1 = /** @type {(inputs: Contact_Success_Urgentquestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need a quicker answer?`)
};

/**
* | output |
* | --- |
* | "Need a quicker answer?" |
*
* @param {Contact_Success_Urgentquestion1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_success_urgentquestion1 = /** @type {((inputs?: Contact_Success_Urgentquestion1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_Urgentquestion1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_success_urgentquestion1(inputs)
	return en_contact_success_urgentquestion1(inputs)
});
export { contact_success_urgentquestion1 as "contact_success_urgentQuestion" }